/**
 * Studio uses Redux to manage state (https://redux.js.org/). These are wrapper
 * functions around react-redux types to subscribe to chanages to the store,
 * get the dispatcher, etc.
 *
 * @module
 */
import shallowCompare from "common/utils/shallowCompare";
import { useDispatch, useSelector } from "react-redux";
import type { Editor, EditorDispatch } from "./editorTypes";

export function useEditorDispatch(): EditorDispatch {
  return useDispatch() as EditorDispatch;
}

export function useEditorSelector<T extends object | undefined>(
  selector: (ed: Editor) => T,
  compare: (left: T, right: T) => boolean = shallowCompare,
) {
  return useSelector(selector, compare);
}
